import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Cover from '../../components/cover/cover'
import ContactForm from '../../components/form/form'

// image imports
import cover from "../../images/mumbai-cover.jpg"

const MumbaiPage = () => (
  <Layout>
    <SEO title="Mumbai Chapter" />
    <Cover
      image={cover}
      title={`We Clothe Them, Mumbai`}
    />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading `}>Chapters &middot; Mumbai</h6>
        <h2 className={``}>About the Chapter</h2>
        <p className={``}>
        WCT has been gifting the joy and warmth of clothing in the city of dreams since March 2018. Our Mumbai chapter, based out of Powai is headed by Bhumika Jain and Preeti Asthana. One smile at a time, the chapter is expanding quickly. 
        </p>
        <p>We have been supported by our eminent collaborators – IIT Bombay and TedX Bandra. Many collection drives together with home collection of clothes have been organized in the city. Donation of clothes at AngelXpress as well as street distributions have been conducted with full enthusiasm.</p>
      </div>
    </section>
    <section className={`grey sm`}>
      <div className={`content-sm`}>
        <h2 className={``}>
          <span>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </span>{" "}
          Reach Out
        </h2>
        <div className={`chapter-contact`}>
          <p>We welcome you to collaborate with us, whether you wish to donate or for those in need or if you would like to volunteer.</p>
          <p>
            <b>Email:</b> mumbai@weclothethem.com
          </p>
          <p>
            <b>Contact:</b> +91-9999298196, +91-8700535580{" "}
          </p>
        </div>
      </div>
    </section>
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading center`}>Contact</h6>
        <h2 className={`center`}>Write to Us</h2>
        <ContactForm />
      </div>
    </section>
  </Layout>
)

export default MumbaiPage
